// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

const toolbar = [
  'styleselect formatselect  fontselect fontsizeselect  forecolor backcolor bold  italic underline strikethrough alignleft aligncenter alignright outdent indent ',
  'blockquote undo redo removeformat subscript superscript code toc hr bullist numlist link image charmap preview anchor pagebreak insertdatetime media table emoticons searchreplace  fullscreen',
]

export default toolbar
